import { getFirestore, doc, getDoc, setDoc, updateDoc, collection, query, where, orderBy, limit, startAfter, getDocs, deleteField, } from "firebase/firestore";
import { PageCursor } from "../../domain/models/pagination";
import { mapFirebaseError } from "./errorMapper";
import { userDTOtoDomain } from "./mappers";
export class FirestoreUserProfileRepository {
    db = getFirestore();
    coll = collection(this.db, "users");
    async fetchProfile(userId) {
        try {
            const snap = await getDoc(doc(this.coll, userId));
            if (!snap.exists())
                return null;
            return userDTOtoDomain(snap.id, snap.data());
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async fetchPage(pageSize, after) {
        try {
            let q = query(this.coll, orderBy("__name__"), limit(pageSize));
            if (after?.backing) {
                q = query(q, startAfter(after.backing));
            }
            const snap = await getDocs(q);
            const items = snap.docs.map((d) => userDTOtoDomain(d.id, d.data()));
            const nextCursor = snap.docs.length === pageSize ? new PageCursor(snap.docs[snap.docs.length - 1]) : null;
            return { items, nextCursor };
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async createProfile(profile) {
        try {
            await setDoc(doc(this.coll, profile.id), {
                name: profile.name,
                email: profile.email,
                phone: profile.phone,
                profileImageUrl: profile.profileImageUrl ?? null,
                username: profile.username,
                hasPhone: profile.hasPhone,
                isEmailVerified: profile.isEmailVerified,
                ratingAverage: null,
                ratingCount: null,
                ratingSum: null,
                deletionRequestedAt: null,
                deletionScheduledAt: null,
            });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updateProfile(profile) {
        try {
            await setDoc(doc(this.coll, profile.id), {
                name: profile.name,
                email: profile.email,
                phone: profile.phone,
                profileImageUrl: profile.profileImageUrl,
                username: profile.username,
                hasPhone: profile.hasPhone,
                isEmailVerified: profile.isEmailVerified,
            }, { merge: true });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updateUsername(userId, username) {
        try {
            await updateDoc(doc(this.coll, userId), { username });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updateEmail(userId, email, isVerified) {
        try {
            await updateDoc(doc(this.coll, userId), { email, isEmailVerified: isVerified });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updatePhone(userId, phone) {
        try {
            await updateDoc(doc(this.coll, userId), { phone });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async updateBasicInfo(userId, name, profileImageUrl) {
        try {
            const data = { name };
            if (profileImageUrl !== undefined) {
                data.profileImageUrl = profileImageUrl ?? deleteField();
            }
            await updateDoc(doc(this.coll, userId), data);
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async markEmailVerified(userId) {
        try {
            await updateDoc(doc(this.coll, userId), { isEmailVerified: true });
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
    async phoneExists(phone) {
        try {
            const q = query(this.coll, where("phone", "==", phone), where("deletionScheduledAt", "==", null));
            const snap = await getDocs(q);
            return !snap.empty;
        }
        catch (e) {
            throw mapFirebaseError(e);
        }
    }
}
//# sourceMappingURL=FirestoreUserProfileRepository.js.map